export function addToCalendar() {
    let getUrlParameter = function getUrlParameter(sParam) {
        let sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    if (getUrlParameter('calendar') !== false && getUrlParameter('ticket') !== false) {
        let $calendar_links = $('.calendar-links');
        let calendar = getUrlParameter('calendar');
        let ticket = getUrlParameter('ticket');
        let link;

        if (calendar === 'local') {
            link = $calendar_links.find('.ticket-' + ticket).find('a.icon-ical').attr('href');
        }
        if (calendar === 'google') {
            link = $calendar_links.find('.ticket-' + ticket).find('a.icon-google').attr('href');
        }
        if (calendar === 'yahoo') {
            link = $calendar_links.find('.ticket-' + ticket).find('a.icon-yahoo').attr('href');
        }

        window.location = link;

        if (calendar === 'local') {
            setTimeout(function () {
                window.close();
            }, 500);
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/add-to-calendar.js